import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { Helmet } from "react-helmet-async"; // <-- Ajout de Helmet pour le SEO

import API from "../services/api";
import "../styles/AuthPages.css";
import "../styles/RegisterPage.css";

function RegisterPage() {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // État pour afficher/masquer
  const navigate = useNavigate();

  const register = async () => {
    if (!username || !email || !password) {
      alert("Tous les champs sont obligatoires");
      return;
    }
    if (password.length < 6) {
      alert("Mot de passe trop court");
      return;
    }

    try {
      const res = await API.post("/users/register", {
        username,
        email,
        password,
      });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));

      alert("Compte créé ✅");
      navigate("/profile");
    } catch (error) {
      console.error(error);
      alert("Erreur inscription");
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    const res = await API.post("/users/google", {
      credential: credentialResponse.credential,
    });

    localStorage.setItem("token", res.data.token);
    localStorage.setItem("user", JSON.stringify(res.data.user));

    window.location.href = "/profile";
  };

  return (
    <div className="auth-page">
      {/* --- BLOC REFERENCEMENT / SEO --- */}
      <Helmet>
        <title>Inscription - Rejoignez FootVision Live</title>
        <meta name="description" content="Créez votre compte FootVision dès aujourd'hui pour suivre les live scores, ajouter vos matchs favoris et accéder à nos analyses de football." />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Créer un compte – FootVision" />
        <meta property="og:description" content="Rejoignez notre communauté de passionnés de statistiques et de pronostics football." />
        <meta property="og:url" content="https://www.footvisionlive.com/register" />
        <meta property="og:image" content="https://www.footvisionlive.com/logo1.png" />
        <meta name="robots" content="noindex, nofollow" /> {/* Empêche l'indexation inutile du formulaire par les robots */}
      </Helmet>

      <div className="auth-card">
        <div className="google-login-wrapper">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => console.log("Erreur Google")}
          />
        </div>
        
        <h1>Inscription</h1>
        
        <input
          type="text"
          placeholder="Nom utilisateur"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        
        <input
          type={showPassword ? "text" : "password"} // Changement dynamique du type
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {/* Bloc Checkbox pour afficher/masquer le mot de passe */}
        <div className="show-password-container">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={showPassword}
              onChange={() => setShowPassword(!showPassword)}
            />
            <span className="checkbox-text">Afficher le mot de passe</span>
          </label>
        </div>

        <button onClick={register}>Créer un compte</button>

        <div className="forgot-password">
          <span onClick={() => navigate("/login")} style={{ cursor: "pointer" }}>
            Vous avez déjà un compte ? Connectez-vous
          </span>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;